<template lang="pug">
table.table.is-striped
	tbody
		tr
			td Name On Card:
			td {{ card.nameOnCard }}
		//tr
		//	td Payment Method:
		//	td {{ card.paymentMethod }}
		tr
			td Credit Card Number:
			td {{ cardNumber }}
		tr
			td Expiration Date:
			td {{ card.expireMonth }} / {{ card.expireYear }}
</template>
<script>
import _ from 'lodash'

export default {
	name: 'credit-card',
	props: ['card'],
	computed: {
		cardNumber () {
			let numberToShow = ''
			if (_.isString(this.card.cardNumber)) {
				numberToShow = '**** **** **** ' + this.card.cardNumber.substring(12, 15)
			}
			return numberToShow
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/common/components/credit-card.vue